





















import {Component, Vue} from 'vue-property-decorator';
import { Inject } from 'vue-typedi';
import {StoreService} from '@/services/StoreService';
import { Store } from '@/model/Store';
import {PageName} from "@/configuration/pages";

@Component
export default class StoreBody extends Vue {

    @Inject()
    storeService!: StoreService;

    private store: Store = null;
    private allStores: Store[] = [];

    created() {
        this.getAllStores();
    }

    private getAllStores() {
        this.storeService.getStores().then(data => {
            if (!data.stores) {
                this.allStores = [];
                return;
            }

            this.allStores = data.stores.sort((a, b) => {
                const labelA = a.storeLabel || '';
                const labelB = b.storeLabel || '';

                return labelA.localeCompare(labelB);
            });
        })
    }

    onSelectStore() {
        this.storeService.updateStoreInSession(this.store, PageName.ORDERS);
    }
}
